/* unplugin-vue-components disabled */import { render } from "./rightAside.vue?vue&type=template&id=06844c71&scoped=true"
import script from "./rightAside.vue?vue&type=script&lang=js"
export * from "./rightAside.vue?vue&type=script&lang=js"

import "./rightAside.vue?vue&type=style&index=0&id=06844c71&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06844c71"]])

export default __exports__